export default {
    SET_THEME: 'SET_THEME',

    SET_LANG: 'SET_LANG'
}
